/**
 * Builds a query URL for lead list routes preserving dashboard filters
 * (period, customRange, status, source, leadWarmth, salesPerson).
 */
export function buildLeadFilterUrl(
  basePath,
  { status, source, leadWarmth, salesPerson, period, customRange } = {},
) {
  const params = new URLSearchParams()

  if (status && status !== 'all') {
    params.set('status', status)
  }

  if (source && source !== 'all') {
    params.set('source', String(source).toLowerCase())
  }

  if (leadWarmth && leadWarmth !== 'all') {
    params.set('leadWarmth', String(leadWarmth).toLowerCase())
  }

  if (salesPerson && salesPerson !== 'all') {
    params.set('salesPerson', salesPerson)
  }

  if (period) {
    params.set('period', period)
    if (period === 'custom') {
      if (customRange?.startDate) params.set('startDate', customRange.startDate)
      if (customRange?.endDate) params.set('endDate', customRange.endDate)
    }
  }

  const query = params.toString()
  return query ? `${basePath}?${query}` : basePath
}
